import React from 'react';
import { useTranslation } from 'react-i18next';
import ListPageHeader from '@shared/ListPageHeader';
import PartnerApiLogList from '@shared/partner_api_logs/PartnerApiLogList';
import { partnerApiLogService } from '@services/admin/partnerApiLogService';

export default function AdminPartnerApiLogsList() {
  const { t } = useTranslation();

  return (
    <div>
      <ListPageHeader basePath="/admin" items={['developer_tools', 'developer_tools.partner_api_logs']} />
      <PartnerApiLogList service={partnerApiLogService} />
    </div>
  );
}
